import { render, staticRenderFns } from "./Return_product.vue?vue&type=template&id=5c2a6412&scoped=true&"
import script from "./Return_product.vue?vue&type=script&lang=js&"
export * from "./Return_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a6412",
  null
  
)

export default component.exports